import { createFileRoute, redirect } from '@tanstack/react-router'
import { AiCosts } from '@/features/ai-costs'

export const Route = createFileRoute('/_authenticated/ai-costs')({
  beforeLoad: ({ context }) => {
    // Admin-only — médecins / bsohtak_doctor n'ont pas le droit de voir
    // la consommation Gemini de toute la plateforme.
    const role = (context as { user?: { user_role?: string } }).user?.user_role
    if (role !== 'admin') {
      throw redirect({ to: '/' })
    }
  },
  component: AiCosts,
})
